import { MathUtils } from '../../../../../shared/utils/MathUtils.ts';
import { UIGameTimedAnimation } from './UIGameTimedAnimation.ts';
export class UIGameFadeAnimation extends UIGameTimedAnimation {
    start() {
        this.viewToAnimate.alpha = this.options.initialAlpha;
        super.start();
        return this;
    }
    updateAnimation(deltaTime, elapsedMS, completionPercentage) {
        this.completionPercentage = completionPercentage != undefined ? completionPercentage : this.totalElapsedMS / this.duration;
        this.viewToAnimate.alpha = this.calculateAlpha(deltaTime);
    }
    calculateAlpha(deltaTime) {
        if (this.completionPercentage < this.options.completionPercentageToStartFade) return this.viewToAnimate.alpha;
        const fadeAdjustment = this.options.fadeSpeed * deltaTime * (this.options.isFadeIn ? 1 : -1);
        const newAlpha = this.viewToAnimate.alpha + fadeAdjustment;
        return MathUtils.clampBetweenZeroAndOne(newAlpha);
    }
    resetToDefaultState() {
        this.viewToAnimate.alpha = this.options.isFadeIn ? 1 : 0;
    }
    static getDefaultOptions() {
        return {
            initialAlpha: 0,
            fadeSpeed: 0.1,
            completionPercentageToStartFade: 0.5,
            isFadeIn: true
        };
    }
    constructor(viewToAnimate, animationDuration = 500, options){
        super(animationDuration), this.forceEnableAnimation = false, this.completionPercentage = 0;
        this.viewToAnimate = viewToAnimate;
        this.options = options !== null && options !== void 0 ? options : UIGameFadeAnimation.getDefaultOptions();
    }
}
